import { useCallback, useState } from 'react'
import ApiClient from '../../../services/api/ApiClient'
import { showToast } from '../../shared/Toast'
import issueExportUrl from '../TriggeredAlerts/issueExportUrl'

const SUCCESS_MSG = 'L’export du tableau des alertes a bien été effectué.'
const ERROR_MSG = 'Une erreur est survenue lors de l’export.'

const useIssueExport = (collectId, toastContainerId) => {
  const [exporting, setExporting] = useState(false)

  const exportTo = useCallback(async(format, params) => {
    if (exporting)
      return
    setExporting(true)
    try {
      await ApiClient.get(issueExportUrl(collectId, format, params))
      showToast(SUCCESS_MSG, 'success', toastContainerId)
    } catch {
      showToast(ERROR_MSG, 'error', toastContainerId)
    } finally {
      setExporting(false)
    }
  }, [collectId, toastContainerId, exporting])

  return { exportTo, exporting }
}

export default useIssueExport
